import { AspObject } from '@core_n/asp/AspObject';
import { TrackCoreObject } from '@core_n/asp/TrackCoreObject';
import * as projConsts from '../common/projConsts';
import * as projEnums from '../common/projEnums';
import * as enums from './../../core/app/common/enums';
import * as projMsgs from '../msg/projMsgs';
import { IMapMngr } from '@core_n/asp/interfaces';
import { AppInjector } from '@core_n/common/inject';
import { UserActionService } from '@core_n/user-action/user-action.service';
import { UserActionsService } from '../user-actions/user-actions.service';
import { TracksCorePool } from '@core_n/asp/TracksCorePool';
import { TrackObject } from './TrackObject';
import { AroTrackService } from '../aro/aro-track.service';
import { settings } from 'cluster';
import { userSettings } from '@core_n/common/settings';


export class TracksPool extends TracksCorePool {

  constructor() {
    super();
  }

  protected createTrack(msgObj): TrackCoreObject {
    return new TrackObject(this, this.objectType, msgObj.TrackId);
  }

  contextMenuActions(obj: AspObject): number[] {
    let actions = super.contextMenuActions(obj);
    actions.push(projConsts.USER_ACTION_DROP_TRACK);
    return actions;
  }

  canBePicked(action: number, actionObj: AspObject, nextObj: AspObject): boolean {
    if (action == projConsts.USER_ACTION_MERGE_TRACKS) {
      if (nextObj != actionObj && nextObj instanceof TrackCoreObject) {
        let track = nextObj as TrackCoreObject;
        return true;
      }
    }
    else if (action == projConsts.USER_ACTION_SET_DOUBLE_FLAG)
      return false;
    else
      return super.canBePicked(action, actionObj, nextObj);
  }

  handleUserAction(action: number, obj: AspObject, mapMngr: IMapMngr): boolean {
    if (action == projConsts.USER_ACTION_DROP_TRACK) {
      // let dropTrackMsg = new projMsgs.DropTrack();
      // dropTrackMsg.TrackNumber = (obj as TrackCoreObject).trackID;
      // AppInjector.get(UserActionService).sendUserAction(dropTrackMsg);
      return true;
    }

    if (action == projConsts.USER_ACTION_MERGE_TRACK) {
      if (obj && obj.active() && obj instanceof TrackCoreObject) {
        this.userAction = action;
        this.userActionObj = obj;
        const userActionsService = AppInjector.get(UserActionsService);
        userActionsService.activateAction(action, obj, this);
      }
      return true;
    }
    else if (action == 1000) {
      if (userSettings.userPerm == enums.Permission.USER)
        return true;
      let trk = obj as TrackObject;
      AppInjector.get(AroTrackService).showTrack(trk);
      return true;
    }
    else
      return super.handleUserAction(action, obj, mapMngr);
  }

  // Handle user action respone
  response(action: number, status: boolean, objects?: AspObject[], data?: any): void {
    if (status && this.userAction == action && typeof this.userActionObj != 'undefined' && this.userActionObj.active()) {
      if (this.userAction == projConsts.USER_ACTION_MERGE_TRACKS) {
        if (typeof objects != 'undefined' && objects.length == 1 && objects[0].active() && objects[0] instanceof TrackCoreObject) {
          let firstTrack = this.userActionObj as TrackCoreObject;
          let secondTrack = objects[0] as TrackCoreObject;

          // let mergeTracksMsg = new projMsgs.MergeTracks();
          // mergeTracksMsg.FirstTrackNumber = firstTrack.trackID;
          // mergeTracksMsg.SecondTrackNumber = secondTrack.trackID;
          // // mergeTracksMsg.source = projEnums.FieldSource.Menatev;
          // AppInjector.get(UserActionService).sendUserAction(mergeTracksMsg);
        }
      }
      else if (this.userAction == projConsts.USER_ACTION_SET_DOUBLE_FLAG) {
        let track = this.userActionObj as TrackCoreObject;

        // let setDoubleFlagMsg = new projMsgs.SetDoubleFlagMsg();
        // setDoubleFlagMsg.trackId = track.trackID;
        // setDoubleFlagMsg.value = data.isDouble;
        // setDoubleFlagMsg.source = data.source;
        // AppInjector.get(UserActionService).sendUserAction(setDoubleFlagMsg);
      }
    }

    super.response(action, status, objects, data);
  }

}
